/** The set of known roles.
 * KEEP IN SYNC WITH Omnius.Custom.API/Authorization/Roles.cs
 * **AND** with Omnius 1.0 Roles enum
 * **AND** with the Role table in the database (via 1.0 bootstrapper)
 */
enum Roles {
  ACCESS_API_INTEGRATION = "Access API Integration",
  ACCESS_REPORTS_ADMIN = "Access Reports Admin",
  ACCESS_REPORTS_VIEWER = "Access Reports Viewer",
  ACCESS_REPORTS_WIZARD_ADMIN = "Access Reports Wizard Admin",
  ACCURACY_EVIDENCE_VIEWER = "Accuracy Evidence Viewer",
  ACCURACY_LICENSE_TIER_1 = "Accuracy License Tier 1",
  ACCURACY_LICENSE_TIER_2 = "Accuracy License Tier 2",
  ACCURACY_XID_VIEWER = "Accuracy XID Viewer",
  API_USER = "API User",
  CCIIO_QHP_NETWORK_REPORTER = "CCIIO QHP Network Reporter",
  CCIIO_PPF_REPORT_USER = "CCIIO PPF Report User",
  CCIIO_VALIDATIONS_REPORT_USER = "CCIIO Validations Report User",
  CLIENT_ADMIN = "Client Admin",
  CMS_APPLICATION_CREDIT_VIEWER = "CMS Application Credit Viewer",
  COMPETITIVE_INSIGHTS_USER = "Competitive Insights User",
  DASHBOARD_SUMMARY_USER = "Dashboard Summary User",
  DISTINCT_SERVICING_USER = "Distinct Servicing User",
  ECD_DEMO_ADMIN = "ECD Demo Admin",
  ENTERPRISE_COMPLIANCE_DASHBOARD_USER = "Enterprise Compliance Dashboard User",
  EXCEPTION_MANAGER = "Specialty Exception Manager",
  GAP_RESOLUTION_STATUS_MANAGER = "Gap Resolution Status Manager",
  GEOGRAPHY_AWARE_DISTANCE_USER = "Geography Aware Distance User",
  INTERNAL_ONLY_CMS_EXCEPTION_DOCUMENT_MANAGER = "Internal Only CMS Exception Document Manager",
  MAINTENANCE_ADMIN = "Maintenance Admin",
  MEDICARE_OPT_OUTS = "Medicare Opt Outs",
  MEMBERSHIP_RISK_USER = "Membership Risk User",
  NET_NEW_PROVIDER_USER = "Net New Provider User",
  NETWORK_OUTREACH_USER = "Network Outreach User",
  NETWORK_PERFORMANCE_ADMIN = "Network Performance Admin",
  OIG = "OIG",
  OPERATIONS_ADMIN = "Operations Admin",
  OPERATIONS_USER = "Operations User",
  PATTERN_OF_CARE_USER = "Pattern of Care User",
  PERFORMANCE_MONITOR = "Performance Monitor",
  PNDS_API = "PNDS API",
  PRECLUDED_PROVIDER_USER = "Medicare Precluded Provider User",
  PREVIEW = "Preview",
  PROJECTION_PROCESSOR = "Manual Projection Processor",
  PROVIDER_AFFILIATIONS_INSIGHTS = "Provider Affiliations Insights",
  PROVIDER_CLAIMS_INSIGHTS = "Provider Claims Insights",
  PROVIDER_EXCLUDE_USER = "Provider Exclude User",
  PROVIDER_NETWORK_IMPORT = "Provider Network Import",
  PROVIDER_TARGET_USER = "Provider Target User",
  PROVIDER_VALIDATION_USER= "Provider Validation User",
  QESI_INTEGRATION_USER = "QESI Integration User",
  QUALITY_SCORES = "Quality Scores",
  QUEST_ADMIN = "Quest Admin",
  QUEST_DOCUMENT_ADMIN = "Quest Document Admin",
  QUEST_INTERNAL_PROJECT_SHARING_USER = "Quest Internal Project Sharing User",
  QUEST_INTERNAL_REPORTS = "Quest Internal Reports",
  QUEST_USER = "Quest User",
  QUEST_VIEWER = "Quest Viewer",
  REPORT_PRESET_ADMIN = "Report Preset Admin",
  RESOURCE_ADMIN = "Resource Admin",
  ROUTING_DISTANCE_USER = "Routing Distance User",
  SIMULATED_PROJECTION = "Simulated Projection",
  SOFTWARE_LICENSE = "Software License",
  SOFTWARE_LICENSE_ADMIN = "Software License Admin",
  SPECIALTY_EXCEPTION_REVIEWER_ADMIN = "Specialty Exception Reviewer Admin",
  STANDARDS_CREATOR_USER = "Standards Creator User",
  STRAIGHT_LINE_DISTANCE_USER = "Straight Line Distance User",
  TABLE_CONFIGURATION_USER = "Table Configuration User",
  TERM_PROVIDER_ADMIN = "Term Provider Admin",
  TERM_PROVIDER_VIEWER = "Term Provider Viewer",
  TIN_VIEWER = "TIN Viewer",
  TOKEN_USER = "Token User",
  UTILITY_ADMIN = "Utility Admin",
  VIEWER = "Viewer",
  VOLUME_REPORTER = "Volume Reporter",
  VOLUME_TARGET = "Volume Targeting",
  VOLUME_TERMINATOR = "Volume Terminator",
}

export default Roles;
